(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection"]) return;
  try {
    
$(function() {
  $('.rte a').addClass('btn_c btn_collection');
});

  } catch(e) { console.error(e); }
})();
})();
